import React from "react";
import LifeBanner from "../components/lifeBanner/LifeBanner";
import MeetOurTeam from "../components/meetourteam/MeetOurTeam";
import PerkAndBenifit from "../components/perkandbenifit/PerkAndBenifit";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import CeoIntro from "../components/CeoIntro/CeoIntro";
import LifeGallery from "../components/LifeGallery/LifeGallery";
import ContactSection from "../components/contactSection/ContactSection";
import { useSelector } from "react-redux";
import Footer from "../components/footer/Footer";
import { useTranslation } from "react-i18next";
import PartnersAndTeams from "../components/partnersAndTeam";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import LifeAtAboutSection from "../components/LifeAtAboutSection/LifeAtAboutSection";
import LifeAtBitsclanOurValue from "../components/LifeAtBitsclanOurValue/LifeAtBitsclanOurValue";
import LifeAtBitsclanTabs from "../components/LifeAtBItsclanTabs/LifeAtBitsclanTabs";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import LifeAtBitsclanCta from "../components/LifeAtBitsclanCTA/LifeAtBitsclanCta";
import AwardsAndPartners from "../components/AwardsAndPartners/AwardsAndPartners";

const LifeAtBitsclan = () => {
  const country = useSelector((state) => state.country.name);

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("lifeAtBitsclanTitle", {
    returnObjects: false,
  });

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });

  const softwareCompanyCtaText = {
    heading: "Ready to Build the Future With Us?",
    subHeading: "Join our team of passionate innovators",
    buttonText: "Join Our Talent Network"
  }

  return (
    <>
      <Helmet>
        <title>About Us | Bitsclan</title>
        <meta
          name="description"
          content="Your trusted IT services partner. We are specialized in AI, Software, and blockchain development for startups and enterprises worldwide. Let’s build together!"
        />
      </Helmet>
      <MegaMenu />
      <LifeBanner />
      <LifeAtAboutSection />
      <CeoIntro />
      <LifeAtBitsclanOurValue />
      {/* <MeetOurTeam /> */}
      <LifeAtBitsclanTabs />
      <AwardsAndPartners />
      <LifeGallery />
      {/* <NewTestimonials shortHeading="Our Testimonials" mainHeading="See Our <span>Clients</span>"/> */}
      {/* <PartnersAndTeams /> */}
      <PerkAndBenifit />
      {/* <LifeAtBitsclanCta /> */}
      {/* <ContactSection /> */}
      <SoftwareCompanyCta content={softwareCompanyCtaText} />
      <Footer />
      {/* {country !== "PK" && <ContactSection />}
      {country !== "PK" && <Footer />} */}
    </>
  );
};

export default LifeAtBitsclan;
